import bg from '../../assets/images/Product/Progress/pattern-10.png';
import Graph from "../../assets/images/Product/Progress/graph.png";
import './progress.css';
import { Link } from 'react-router-dom';

export default function Progress() {
    return (
        <>
            <section className="company-one">
                <div
                    className="company-one_pattern-layer"
                    style={{ backgroundImage: `url(${bg})` }}
                />
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* Company One */}
                        <div className="company-one_title-column col-lg-6 col-md-12 col-sm-12">
                            <div className="company-one_title-inner">
                                {/* Sec Title */}
                                <div className="sec-title-two light">
                                    <div className="sec-title-two_title">Company Progress</div>
                                    <h2 className="sec-title-two_heading">
                                       Horizon Webinfo – Smart Business Solutions for Growing Companies
                                    </h2>
                                    <div className="sec-title-two_text">
                                        At Horizon Webinfo Pvt. Ltd. we build powerful, easy-to-use software solutions that help businesses save time, reduce errors, and grow faster.
                                    </div>
                                     <div className="sec-title-two_text">
                                       Explore our specialized products and services designed for modern Indian businesses.
                                    </div>
                                </div>
                                <a className="btn-style-five theme-btn">
                                    <div className="btn-wrap">
                                       <Link to='/contact-us'> <span className="text-one">Contact us</span></Link>
                                      <Link to='/contact-us'> <span className="text-two">Contact us</span></Link>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* Graph Column */}
                        <div className="company-one_graph-column col-lg-6 col-md-12 col-sm-12">
                            <div className="company-one_graph-inner">
                                <img src={Graph} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}